<template>
  <BAutocompleteSelect
    ref="autocomplete"
    v-bind="$attrs"
    label="Статус Меры"
    no-data-text="Статус не найден"
    :options="options"
    v-on="$listeners"
  >
    <template #selection="{ item }">
      <v-chip :color="getOptions(item).color" label small>
        {{ getOptions(item).name }}
      </v-chip>
    </template>

    <template #item="{ item }">
      <v-chip :color="getOptions(item).color" label small>
        {{ getOptions(item).name }}
      </v-chip>
    </template>
  </BAutocompleteSelect>
</template>

<script>
import { openApiMixin } from './mixins'
import {
  RoadmapEventStatuses,
  getRoadmapEventStatusesLabel,
  getRoadmapEventStatusesColor,
} from '@/typings/api/RoadmapEvent'
import BAutocompleteSelect from './BAutocompleteSelect.vue'


export default {
  name: 'BAutocompleteEventStatus',
  components: {
    BAutocompleteSelect,
  },
  mixins: [
    openApiMixin,
  ],
  data: () => ({
    options: Object.values(RoadmapEventStatuses),
  }),
  methods: {
    getOptions(value) {
      return {
        value,
        name: getRoadmapEventStatusesLabel(value),
        color: getRoadmapEventStatusesColor(value),
      }
    },
  },
}
</script>
